import styled from 'styled-components';

import { FontWeight, Color, Grid, Spacing, Media } from '../../theme';
import { hexToRgba } from '../../utils';
import { Button } from '../../uiComponents';

import { HalfBoxData, PhotoHeaderContainerData } from './photoHeader.types';

export const Container = styled.div<PhotoHeaderContainerData>`
  width: 100%;
  height: 700px;
  background: url(${(props) => props.background}) center;
  position: relative;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  ${Media.tablet`
    height: 480px;
  `}
`;

export const InnerContainer = styled.div`
  width: calc(100% - 2 * ${Spacing.DesktopWide});
  height: calc(100% - 120px);
  background-color: ${hexToRgba(Color.black, 0.3)};
  padding: 0 ${Spacing.DesktopWide} 120px;
  display: flex;
  align-items: flex-end;
  position: absolute;
  ${Media.desktop`
    padding: 0 ${Spacing.Desktop} 120px;
    width: calc(100% - 2 * ${Spacing.Desktop});
  `}
  ${Media.tablet`
    padding: 0 ${Spacing.Tablet} 120px;
    width: calc(100% - 2 * ${Spacing.Tablet});
  `}
`;

export const LocalButton = styled(Button)``;

export const Content = styled.div`
  width: 100%;
  max-width: ${Grid.DesktopNarrow};
  margin: 0 auto;
  color: ${Color.white};
  ${Media.tablet`
    display: none;
  `}
`;

export const SubHeaderContainer = styled.div`
  overflow: hidden;
`;

export const Subheader = styled.h2`
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 1.09px;
  line-height: 15px;
  text-transform: uppercase;
  margin: 0;
`;

export const HeadersBox = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

export const HeaderContainer = styled.div`
  overflow: hidden;
  margin: 20px 0 60px;
`;

export const Header = styled.h1`
  font-size: 60px;
  word-break: break-word;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0.2px;
  line-height: 52px;
  margin-bottom: 10px;
  ${Media.tablet`
    font-size: 40px;
    letter-spacing: 0;
    line-height: 52px;
  `}
`;

export const HalfBox = styled.div<HalfBoxData>`
  width: 50%;
  background-color: ${(props: HalfBoxData) => props.backgroundColor ? props.backgroundColor : Color.secondary};
  height: 45px;
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const TopContentContainer = styled.div`
  width: calc(100% - 2 * ${Spacing.Tablet});
  padding: 60px ${Spacing.Tablet};
  margin: 0 auto;
  color: ${Color.black};
  display: none;
  ${LocalButton} {
    color: ${Color.black};
    border-color: ${Color.mediumLightGrey};
    &:hover {
      background-color: ${Color.transparent};
    }
  }
  ${Media.tablet`
    display: block;
  `}
`;

export const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  ${Media.desktopWide`
    max-width: none;
    max-height: 100%;
  `}
`;
